import { render, staticRenderFns } from "./ProgramTab.vue?vue&type=template&id=8a1e1f8c&"
import script from "./ProgramTab.vue?vue&type=script&lang=js&"
export * from "./ProgramTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports